
<template>
  <div>
    <CCard>
      <CCardBody>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <CForm @submit.stop.prevent="handleSubmit(submit)">
            <CRow>
              <CCol md="6">
                <validation-provider rules="required" v-slot="{ errors }" name="Jenis Cuti">
                  <CInput
                    label="Jenis Cuti"
                    v-model="form.leave_type"
                    :invalid-feedback="errors[0]"
                    :isValid="!errors[0]"
                  ></CInput>
                </validation-provider>
                <validation-provider rules="required" v-slot="{ errors }" name="Urutan Cuti">
                  <CInput
                    label="Urutan Cuti"
                    v-model="form.leave_order"
                    :invalid-feedback="errors[0]"
                    :isValid="!errors[0]"
                  ></CInput>
                </validation-provider>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6" class="text-left">
                <CSpinner color="success" size="sm" v-if="loading" />
                <CButton color="primary" class="px-4" type="submit" v-else>Simpan</CButton>
              </CCol>
            </CRow>
          </CForm>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import Swal from "sweetalert2";

export default {
  name: "FormLeave",
  props: ["item"],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      errorMessage: null,
      form: {
        leave_type: null,
        leave_order: null,
      },
      loading: false,
    };
  },
  watch: {
    item: function (item) {
      if (item) {
        this.form.leave_type = item.leave_type;
        this.form.leave_order = item.leave_order;
      }
    },
  },
  methods: {
    async submit() {
      const vm = this;
      try {
        this.loading = true;
        let { status } = this.item
          ? await this.$store.dispatch("general/update", {
              url: 'api/master/leave',
              data: this.form,
              id: vm.item.id,
            })
          : await this.$store.dispatch("general/store", {url: 'api/master/leave', data: this.form});
        if (status >= 200 && status <= 202) {
          Swal.fire({
            title: "Sukses",
            text: "Data berhasil tersimpan!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(() => {
            if (!vm.item) {
              vm.form.nama_layanan = null;
              requestAnimationFrame(() => {
                this.$refs.observer.reset();
              });
            }
            vm.$emit("done");
          });
        }
      } catch (x) {
        console.log(x);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
